import { render, staticRenderFns } from "./supplierServiceTermsUS.vue?vue&type=template&id=42339e3a&scoped=true"
import script from "./supplierServiceTermsUS.vue?vue&type=script&lang=js"
export * from "./supplierServiceTermsUS.vue?vue&type=script&lang=js"
import style0 from "./supplierServiceTermsUS.vue?vue&type=style&index=0&id=42339e3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42339e3a",
  null
  
)

export default component.exports